<template lang="html">
  <div class="">
    <h3 class="mb-4 text-center">Chat {{currentChannel}}</h3>
    <div class="d-flex flex-column coment-area">
      <div class="d-flex flex-column flex-grow" style="overflow-y: scroll" ref="comments">
        <div v-for="com in comments" :key="com.id" div class="">
          <b>{{ com.user.full_name }}:</b>
          {{ com.comment }}
        </div>
      </div>
      <div class="py-2">
        <b-form @submit.prevent="saveComment">
          <b-input v-model="comment" :disabled="is_saving_com"/>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['form', 'channel'],
  data() {
    return {
      comment: null,
      comments: [],
      is_saving_com: false,
    }
  },
  computed: {
    currentChannel(){
      if(this.channel == "client") return "Cliente/Fornitore"
      else return "Partner"
    }
  },
  created() {
    this.refreshComents()
  },
  methods: {
    scrollChatDown() {
      setTimeout(() => {
        this.$refs.comments.scrollTop = this.$refs.comments.scrollTopMax
      }, 10)
    },

    saveComment() {
      this.is_saving_com = true
      let data = {
        comment: this.comment,
        order_id: this.form.id,
        channel: this.channel,
      }
      this.$http.post('order-comments', data).then(res => {
        this.comment = null
        this.comments.push(res.data)
        this.scrollChatDown()
      }).finally(() => {
        this.is_saving_com = false
      })
    },
    refreshComents() {
      this.$http.get('order-comments', {
        params: {
          order_id: this.form.id,
          channel: this.channel,
        }
      }).then(res => {
        this.comments = res.data
        this.scrollChatDown()
      })
    },
  },
}
</script>

<style lang="css" scoped>
</style>
